import { Box, Paper, Table, TableContainer } from "@mui/material";
import { TableBodyComp } from "./table-body";
import { TableHeadComp } from "./table-head";

export default function TableComponent({ data }: { data: any }) {
  return (
    <Box sx={{ position: "relative", mb: 4 }}>
      {/* HUD Decorative Elements */}
      <Box
        sx={{
          position: "absolute",
          top: -10,
          left: -10,
          width: 40,
          height: 40,
          borderTop: "2px solid #00f2ff",
          borderLeft: "2px solid #00f2ff",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          bottom: -10,
          right: -10,
          width: 40,
          height: 40,
          borderBottom: "2px solid #00f2ff",
          borderRight: "2px solid #00f2ff",
        }}
      />

      <TableContainer
        component={Paper}
        sx={{
          background: "rgba(0, 242, 255, 0.02)",
          backdropFilter: "blur(10px)",
          border: "1px solid rgba(0, 242, 255, 0.1)",
          borderRadius: 0,
          boxShadow: "0 0 30px rgba(0, 0, 0, 0.5)",
        }}
      >
        <Table aria-label="galactic table">
          <TableHeadComp />
          <TableBodyComp data={data} />
        </Table>
      </TableContainer>
    </Box>
  );
}
